export default __webpack_public_path__ + "static/media/nikki.acafdb6b.jpg";